export default "__VITE_PUBLIC_ASSET__65ff4a96__"